import {EditorEdits} from "./base/edits";
import {IEditorUtil, ITextEdits} from "@/customizer/interfaces";
import {IEditorModel, IEditorTextElement, Imports, IRootStyle, IFreeObject, IEditorElement} from "./base/editor.interfaces";
import {ICustomizerEditorModel} from "./editor.interface-customizer";



/* tslint:disable no-invalid-this */

const globalImports: Imports = typeof global !== 'undefined' ? global as any : window as any;

const SF = globalImports.SF || (globalImports.SF = {});
SF.Util = SF.Util || {} as IEditorUtil;

// dependencies
const model: IEditorModel = globalImports.SF.Model;

class CustomizerEdits extends EditorEdits {
    protected getTextEditsElement(freeObject: IFreeObject):IEditorTextElement {
        let element: IEditorTextElement;
        if (!freeObject.textEdits) {
            throw new Error('text element without freeObject.textEdits');
        }
        if (freeObject.textEdits.text && freeObject.textEdits.rootStyle && freeObject.textEdits.styles) {
            element = new (model as unknown as ICustomizerEditorModel).TextElement(freeObject.textEdits.text, freeObject.textEdits.rootStyle as unknown as IRootStyle, freeObject.textEdits.styles, freeObject.textEdits as unknown as ITextEdits, freeObject.textEdits.edited);
        } else  {
            const textData = freeObject.textEdits.TLFText ? globalImports.SF.Util.TLF.toData(freeObject.textEdits.TLFText) : freeObject.textEdits;

            // some old projects had fontSizes in strings, cleanup here
            if (textData.rootStyle && textData.rootStyle.fontSize && typeof (textData.rootStyle.fontSize as string|number) === 'string') {
                textData.rootStyle.fontSize = parseInt((textData.rootStyle.fontSize as any as string), 10);
            }

            // create element
            element = new (model as unknown as ICustomizerEditorModel).TextElement(textData.text as string, textData.rootStyle, textData.styles, freeObject.textEdits as unknown as ITextEdits, freeObject.textEdits.edited);
            element.tlf = freeObject.textEdits.TLFText;
        }
        element.preview_image = freeObject.textEdits.preview_image;
        element.edited = freeObject.textEdits.edited;
        element.editable = freeObject.canEdit;
        element.originalHeight = freeObject.textEdits.originalHeight;
        element.customerEditable = freeObject.customerEditable;
        if (freeObject.textEdits.placeHolderTranslations) {
            element.placeHolderTranslations = freeObject.textEdits.placeHolderTranslations;
        }
        if (freeObject.customerEditable !== undefined) {
            freeObject.canEdit = freeObject.customerEditable;
        }
        return element;
    }

    protected setPlatformSpecificDataOnElement(element: IEditorElement, freeObject: IFreeObject):void {
        if (freeObject.customerEditable) {
            element.customerEditable = freeObject.customerEditable;
        }
    }
}

SF.Util.Edits = new CustomizerEdits();